module.exports = __webpack_public_path__ + "images/4982eacc4e4ce41d1099bb272b2d5148-Visit Britain.png";